import { Entry } from '../Entry'

export function Entry20250625() {
  return (
    <Entry title="2025 Jun 25 - v3.10.14">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/17869/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
